var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading-action',{attrs:{"plain":"","type":"danger","action":_vm.onReset}},[_vm._v("重置系统")])}
var staticRenderFns = []

export { render, staticRenderFns }